import { useTour } from '@react-admin/ra-tour';
import { useMemo } from 'react';
import { useGetIdentity } from 'react-admin';

import { MenuBuilder } from '@sh4res/bo-common/components';

import { CompanySelector } from '@Components/CompanySelector';
import { useCompanyDetails } from '@Hooks/useCompanyDetails';
import { getMenuItems } from '@Resources/menu_items';

export const Menu = () => {
  const { data: identity, isLoading } = useGetIdentity();

  const company = useCompanyDetails();

  const menuItems = useMemo(
    () => (identity ? getMenuItems(identity, company) : null),
    [identity, company],
  );
  const [_, { start: startTour }] = useTour();

  if (isLoading || !identity || !menuItems) {
    return null;
  }

  const startTourHandle = () => {
    if (!startTour) {
      return null;
    }
    startTour('welcome-tour');
  };

  return (
    <MenuBuilder
      menuItems={menuItems}
      showUserProfile
      showContactSupport
      showProductTour
      startTourHandle={startTourHandle}
      companySelector={<CompanySelector />}
    />
  );
};
